<template>
  <div :class="{'h5-header': !Boolean(statusBarHeight)}" :style="{height: headerHeight, background:'#fff'}"></div>
</template>

<script>
import { util } from '@didi/soda-common'
const { env } = util
export default {
  data() {
    return {
      statusBarHeight:0,
      htmlFontSize:0
    }
  },
  computed: {
    headerHeight() {
      // rem:当前像素/2/根字体 状态栏高度： ios: 88 安卓：62
      let highlyVariable = 62
      if(env.isIOS) highlyVariable = 88
      return ((this.statusBarHeight + highlyVariable) / 2 / this.htmlFontSize).toFixed(2) + 'rem'
    }
  },
  async mounted() {
    this.$nextTick(async () => {
      let globalParams = await SodaBridge('getGlobalParams', 'badcase') || {}
      this.statusBarHeight = globalParams.data.statusBarHeight*1 || 0
      const fontSize = getComputedStyle(window.document.documentElement)['font-size'] || ''
    this.htmlFontSize = (fontSize.split('px')[0] || 0) *1
     
    })
  },
}
</script>

<style lang="scss" scoped>
.h5-header {
  height: 168px !important; // 待和客户端bridge调试
}
</style>
